var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.state.openedThread
    ? _c(
        "div",
        { style: { height: "100%" } },
        [
          _c(
            "app-chat-conversation",
            {
              key: _vm.conversation.ID,
              attrs: { conversation: _vm.conversation, state: _vm.state },
            },
            [
              _vm._t(
                "header",
                function () {
                  return [
                    _c(
                      "w-list",
                      [
                        _c(
                          "w-list-item",
                          [
                            _c(
                              "w-link",
                              {
                                attrs: {
                                  href: "javascript:void(0)",
                                  to: "/chat/threads",
                                },
                              },
                              [
                                _c("w-fa", {
                                  staticClass: "mr",
                                  attrs: { icon: "arrow-left" },
                                }),
                              ],
                              1
                            ),
                            _c("span", [
                              _vm._v(_vm._s(_vm.state.openedThread.Title)),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
                { slot: "header" }
              ),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }